import { render } from "./tag.vue?vue&type=template&id=6862e6b2"
import script from "./tag.vue?vue&type=script&lang=js"
export * from "./tag.vue?vue&type=script&lang=js"

import "./tag.vue?vue&type=style&index=0&id=6862e6b2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/components/global/tag/tag.vue'],['render',render],['__file',"tag.vue"]])

export default __exports__